const CHANGE_FILTER = 'realhub/admin/layoutTemplateFilters/CHANGE_FILTER'
const CHANGE_MULTIPLE_FILTERS = 'realhub/admin/layoutTemplateFilters/CHANGE_MULTIPLE_FILTERS'

// Initial State
const initialState = {
  filterStatus: 'current',
  filterBrandId: 'all',
  filterLimit: '100',
  filterPublicationId: 'all',
  filterPublicationProductId: 'all',
  filterString: '',
}

// Actions
export function changeFilter(name, value){
  return {
    type: CHANGE_FILTER,
    name,
    value,
  }
}

export function changeMultipleFilters(filters = {}){
  return {
    type: CHANGE_MULTIPLE_FILTERS,
    filters,
  }
}

// Reducer
export default function reducer(state = initialState, action = {}){
  const { type } = action

  switch (type){
    case CHANGE_FILTER:{
      const change = {}
      change[action.name] = action.value
      return Object.assign({}, state, change)
    }
    case CHANGE_MULTIPLE_FILTERS:{
      return Object.assign({}, state, action.filters)
    }
    default:
      return state
  }
}
